export class AdditionalInfo {
  static readonly DESCRIPTION = 'description'
  static readonly KEYWORD = 'keyword'
}
